import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "rannea_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

// Registre multi-groupes : jusqu'à 4 comptes connectés en parallèle (bascule sans déconnexion)
const ACCOUNTS_KEY = "rannea_accounts";
export const MAX_ACCOUNTS = 4;
export const getAccounts = () => {
  try { return JSON.parse(localStorage.getItem(ACCOUNTS_KEY)) || []; } catch { return []; }
};
export const setAccounts = (list) => localStorage.setItem(ACCOUNTS_KEY, JSON.stringify(list.slice(0, MAX_ACCOUNTS)));
export const upsertAccount = (acc) => {
  const list = getAccounts().filter((a) => a.login_id !== acc.login_id);
  list.unshift(acc);
  setAccounts(list);
  return getAccounts();
};
export const removeAccount = (token) => {
  setAccounts(getAccounts().filter((a) => a.token !== token));
  return getAccounts();
};

const api = axios.create({ baseURL: API, withCredentials: true });

// Secours Bearer : sur mobile (Safari ITP, WebView), le cookie httpOnly peut ne pas être renvoyé
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err.response?.data?.detail;
    err.friendly =
      typeof d === "string"
        ? d
        : Array.isArray(d)
          ? d.map((e) => e.msg || JSON.stringify(e)).join(" ")
          : err.response
            ? "Une erreur est survenue côté serveur. Réessayez dans un instant."
            : "Connexion impossible au serveur. Vérifiez votre connexion.";
    return Promise.reject(err);
  }
);

// Les balises média (<img>, <video>, <iframe>) ne peuvent pas envoyer d'en-tête : token en query
export const withToken = (url) => {
  const t = getToken();
  return t ? `${url}${url.includes("?") ? "&" : "?"}token=${encodeURIComponent(t)}` : url;
};

export const fileUrl = (id, extra) => withToken(`${API}/files/${id}/content${extra ? `?${extra}` : ""}`);
export const logoUrl = (bust) => withToken(`${API}/group/logo${bust ? `?v=${bust}` : ""}`);
export const eventCoverUrl = (id, bust) => withToken(`${API}/events/${id}/cover${bust ? `?v=${encodeURIComponent(bust)}` : ""}`);
export const eventVisualUrl = (ev) => {
  const c = ev?.cover_effective;
  if (!c) return null;
  if (c.type === "event") return eventCoverUrl(ev.id, c.updated_at);
  return withToken(`${API}/group/category-image/${c.category}`);
};
export const purchaseItemImageUrl = (id) => withToken(`${API}/purchases/items/${id}/image`);
export const loanJustificatifUrl = (id) => withToken(`${API}/loans/${id}/justificatif`);

export default api;
